<aside class="right-panel">
  <!-- Tab controls -->
  <div class="panel-tabs">
    <button class="panel-tab" [class.active]="activeTab === 1"
            (click)="activeTab = 1" title="Filters">
      <i class="pi pi-filter"></i>
    </button>
    <button class="panel-tab" [class.active]="activeTab === 2"
            (click)="activeTab = 2" title="Notifications">
      <i class="pi pi-flag"></i>
      @if ((notifySvc.unreadCount$ | async)! > 0) {
        <span class="badge">{{ notifySvc.unreadCount$ | async }}</span>
      }
    </button>
    @if (perms.catalogView) {
      <button class="panel-tab" [class.active]="activeTab === 3"
              (click)="activeTab = 3" title="Open Price Requests">
        <i class="pi pi-dollar"></i>
      </button>
    }
  </div>

  <!-- Panel content -->
  <div class="panel-content">
    <!-- Filters Tab -->
    @if (activeTab === 1) {
      <h4>Filters</h4>
      <hr />

      @if (showFilters) {
        <div class="filter-section">
          <label>Global Text Filter</label>
          <input type="text" class="filter-input"
                 [ngModel]="filterSvc.textFilter"
                 (ngModelChange)="onTextChange($event)" />
        </div>

        @if (showDateRange) {
          <div class="filter-section">
            <label>{{ filterContext === 'quote' ? 'Create Date' : 'Transaction Date' }}</label>
            <ul class="filter-options">
              <li>
                <input type="radio" name="dateRange" value="30DAYS"
                       [ngModel]="dateRangePreset"
                       (ngModelChange)="onDateRangeChange($event)" /> Last 30 Days
              </li>
              <li>
                <input type="radio" name="dateRange" value="60DAYS"
                       [ngModel]="dateRangePreset"
                       (ngModelChange)="onDateRangeChange($event)" /> Last 60 Days
              </li>
              <li>
                <input type="radio" name="dateRange" value="YTD"
                       [ngModel]="dateRangePreset"
                       (ngModelChange)="onDateRangeChange($event)" /> YTD
              </li>
              <li>
                <input type="radio" name="dateRange" value="PRIORYEAR"
                       [ngModel]="dateRangePreset"
                       (ngModelChange)="onDateRangeChange($event)" /> Prior Year
              </li>
              <li>
                <input type="radio" name="dateRange" value="ALL"
                       [ngModel]="dateRangePreset"
                       (ngModelChange)="onDateRangeChange($event)" /> View All
              </li>
            </ul>
          </div>
        }

        @if (statusOptions.length > 0) {
          <div class="filter-section">
            <label>Status</label>
            <ul class="filter-options">
              @for (opt of statusOptions; track opt.value) {
                <li>
                  <input type="radio" name="statusFilter" [value]="opt.value"
                         [ngModel]="filterSvc.statusFilter"
                         (ngModelChange)="onStatusChange($event)" /> {{ opt.label }}
                </li>
              }
            </ul>
          </div>
        }
      } @else {
        <p class="no-filters">Navigate to a list page to use filters.</p>
      }
    }

    <!-- Notifications Tab -->
    @if (activeTab === 2) {
      <div class="notify-header">
        <h4>Notifications</h4>
        <div class="notify-actions">
          <button class="notify-btn" (click)="notifySvc.markAllAsRead()" title="Mark all as read">
            <i class="pi pi-check-circle"></i>
          </button>
          <button class="notify-btn" (click)="notifySvc.clearAllRead()" title="Clear read items">
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </div>
      <hr />

      <div class="notify-list">
        @for (note of notifySvc.filtered; track note.notifyresponsekey) {
          <div class="notify-item" [class.unread]="note.sendnotifystatus === 1"
               (click)="onNotificationClick(note)" [title]="note.tooltip">
            <i class="pi" [ngClass]="notifySvc.getIconClass(note.notifytypekey)"></i>
            <span class="notify-text" [innerHTML]="note.responseinfo"></span>
          </div>
        }
        @if (notifySvc.filtered.length === 0) {
          <p class="no-filters">No notifications</p>
        }
      </div>
    }

    <!-- Price Requests Tab -->
    @if (activeTab === 3) {
      <h4>Price Requests</h4>
      <hr />
      <div class="pr-list">
        @for (pr of session.priceRequests; track pr.part_nr) {
          <div class="pr-item">
            <div class="pr-info" [pTooltip]="'Requested on ' + (pr.insertdate | date:'MM/dd/yy')" tooltipPosition="left">
              {{ pr.part_nr }}
              @if (pr.quote_id > 0) {
                <span class="pr-quote">QT# {{ pr.quote_id }}</span>
              }
            </div>
            <button class="pr-cancel" (click)="cancelPriceRequest(pr)" title="Cancel request">
              <i class="pi pi-trash"></i>
            </button>
          </div>
        }
        @if (session.priceRequests.length === 0) {
          <p class="no-filters">No open price requests</p>
        }
      </div>
    }
  </div>
</aside>
